import CalendarIcon from "@mui/icons-material/CalendarTodayRounded";
import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInboxRounded";
import LanguageButton from "@mui/icons-material/LanguageRounded";
import RevertIcon from "@mui/icons-material/ReplayRounded";
import { Button } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { RequestSubmissionInfo } from "../../../../../api/types/dataCollectionTypes";
import UnpublishIcon from "@entrilia/shared/icons/UnpublishIcon";
import DataRequestPageContext from "./DataRequestPageContext";

interface Props {
  allSubmissions: RequestSubmissionInfo[];
  selectedIds: string[];
}

const DataRequestSubmissionsGridToolbar = ({ allSubmissions, selectedIds }: Props) => {
  const {
    onPublishSubmissions,
    onSendSubmissionReminders,
    onUnpublishSubmissions,
    onRequestChangesForSubmissions,
    onDeleteSubmissions,
    onChangeSubmissionsDueDate,
  } = useDefinedContext(DataRequestPageContext);

  const selectedSubmissions = allSubmissions.filter((submission) => selectedIds.includes(submission.id));

  const submissionStatuses = selectedSubmissions.map((submission) => submission.status);
  const hasMixedStatuses = submissionStatuses.some((status) => status !== submissionStatuses[0]);
  const statusOfAllSubmissions = hasMixedStatuses ? undefined : submissionStatuses[0];

  return (
    <>
      <Button
        color="secondary"
        variant="text"
        disabled={statusOfAllSubmissions !== "Draft"}
        startIcon={<LanguageButton />}
        onClick={() => onPublishSubmissions(selectedSubmissions)}
      >
        Publish
      </Button>
      <Button
        color="error"
        variant="text"
        disabled={statusOfAllSubmissions !== "Draft"}
        startIcon={<DeleteIcon />}
        onClick={() => onDeleteSubmissions(selectedSubmissions)}
      >
        Delete
      </Button>
      <Button
        color="secondary"
        variant="text"
        disabled={statusOfAllSubmissions !== "Pending"}
        startIcon={<ForwardToInboxIcon />}
        onClick={() => onSendSubmissionReminders(selectedSubmissions)}
      >
        Send Reminders
      </Button>
      <Button
        color="secondary"
        variant="text"
        disabled={submissionStatuses.includes("Completed")}
        startIcon={<CalendarIcon />}
        onClick={() => onChangeSubmissionsDueDate(selectedSubmissions)}
      >
        Change Due Date
      </Button>
      <Button
        color="secondary"
        variant="text"
        disabled={statusOfAllSubmissions !== "Pending"}
        startIcon={<UnpublishIcon />}
        onClick={() => onUnpublishSubmissions(selectedSubmissions)}
      >
        Unpublish
      </Button>
      <Button
        color="warning"
        variant="text"
        disabled={statusOfAllSubmissions !== "Completed"}
        startIcon={<RevertIcon />}
        onClick={() => onRequestChangesForSubmissions(selectedSubmissions)}
      >
        Request Changes
      </Button>
    </>
  );
};

export default DataRequestSubmissionsGridToolbar;
